import React, {useLayoutEffect} from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {isFunction} from '../../../Tools/TypeOf'

interface ModalCustomInterface {
  bodyClassname?: string,
  contentClassname?: string,
  buttons?: any[],
  buttonsFooter?: any[],
  content?: Object,
  footer?: boolean,
  header?: boolean,
  headerClassname?: string,
  headerTitle?: string,
  headerTitleClassname?: string,
  icon?: string,
  id: string,
  modalClassname?: string,
  onHide: Function,
  show: boolean,
  size?: string,
  title?: string,
  titleClassname?: string,
  onMount?: Function,
  modalBodyId?: string,
  backdrop?: string,
}

const ModalCustom = ({
  show,
  contentClassname,
  bodyClassname,
  buttons,
  buttonsFooter,
  content,
  footer,
  header,
  headerClassname,
  headerTitle,
  headerTitleClassname,
  icon,
  id,
  modalClassname,
  onHide,
  size,
  title,
  titleClassname,
  onMount,
  backdrop = true,
  modalBodyId,
}: ModalCustomInterface) => {
  useLayoutEffect(() => {
    if (onMount && show) {
      onMount()
    }
  })

  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size || 'lg'}
      aria-labelledby={id}
      centered
      id={id}
      contentClassName={contentClassname}
      className={modalClassname || 'text-center'}
      backdrop={backdrop}>
      {header && (
        <Modal.Header closeButton className={headerClassname || ''}>
          <Modal.Title className={headerTitleClassname || ''}>
            {headerTitle}
          </Modal.Title>
        </Modal.Header>
      )}
      {!header && backdrop !== 'static' && (
        <div className="modal-no-header">
          <button
            type="button"
            onClick={onHide}
            className="close text-right px-3 py-2">
            <span aria-hidden="true">×</span>
            <span className="sr-only">Close</span>
          </button>
        </div>
      )}
      <Modal.Body
        className={bodyClassname || 'px-5 pt-0 pb-4'}
        id={modalBodyId}>
        {icon && (
          <FontAwesomeIcon
            icon={icon}
            color="var(--primary)"
            className="mb-1"
            size="2x"
          />
        )}
        {title && <h2 className={titleClassname || ''}>{title}</h2>}
        {content}

        {buttons &&
          buttons.map((item, index) => (
            <Button
              key={index}
              type={item.type}
              disabled={item.disabled}
              onClick={
                isFunction(item.onClick)
                  ? () => {
                      item.onClick(item.onClickParams)
                    }
                  : isFunction(item.func)
                  ? () => item.func()
                  : onHide
              }
              className={`${item.classNames ? ` ${item.classNames}` : ''}`}>
              {item.text}
            </Button>
          ))}
      </Modal.Body>
      {footer && (
        <Modal.Footer className="justify-content-center">
          {buttonsFooter &&
            buttonsFooter.map((item, index) => (
              <Button
                key={index}
                type={item.type}
                variant={item.variant}
                disabled={item.disabled}
                form={item.formId}
                onClick={
                  isFunction(item.onClick)
                    ? () => item.onClick(item.onClickParams)
                    : isFunction(item.func)
                    ? () => item.func()
                    : onHide
                }
                className={`${item.classNames ? ` ${item.classNames}` : ''}`}>
                {item.text}
              </Button>
            ))}
        </Modal.Footer>
      )}
    </Modal>
  )
}

export default ModalCustom
